// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'font-awesome/css/font-awesome.css';
import 'onsenui/css/onsenui-core.css';
import 'onsenui/css/onsen-css-components.css';

import Vue from 'vue';
import VueRouter from 'vue-router';
import $ons from 'vue-onsenui/esm';
import * as VOns from './vue-onsen-components';
import HomePage from './pages/HomePage';
import AddPage from './pages/AddPage';
import DelPage from './pages/DelPage';
import LabelPage from './pages/LabelPage';
import ProductPage from './pages/ProductPage';
import LoginPage from './pages/LoginPage';
import SplashPage from './pages/SplashPage';
import Api from './api';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use($ons);
Object.values(VOns).forEach(comp => Vue.component(comp.name, comp));

const router = new VueRouter({
  routes: [
    { path: "/", component: HomePage },
    { path: "/add", component: AddPage },
    { path: "/del", component: DelPage },
    { path: "/label", component: LabelPage },
    { path: "/label/:id", component: LabelPage },
    { path: "/product", component: ProductPage },  
    { path: "/product/:id", component: ProductPage }
  ]
});

Vue.prototype.$store = new Vue({
  data: () => ({
    authenticated: false,
    addedLabels: [],
    removedLabels: []
  })
});

const baseUrl = window.location.protocol + "//" + 
  window.location.host + "/api/mobile/";
Vue.prototype.$api = new Api(baseUrl);

Object.assign(Storage.prototype, {
  setObject(key, value) {
    this.setItem(key, JSON.stringify(value));
  },
  getObject(key) {
    const s = this.getItem(key);
    return s !== null ? JSON.parse(s) : null;
  }
});

new Vue({
  el: "#app",
  router: router,
  data() {
    return { initialized: false };
  },
  render(h) {
    if (!this.initialized) return h(SplashPage);
    if (!this.$store.authenticated) return h(LoginPage);
    return h("router-view");
  },
  async created() {
    try {
      const credentials = localStorage.getObject("credentials");
      if (credentials) {
        await this.$api.login(credentials);
        this.$store.authenticated = true;
      }
    } catch (err) {
      localStorage.removeItem("credentials");
      util.error(this, "Authentication failed", err);
    } finally {
      this.initialized = true;
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js